module.exports = __webpack_public_path__ + "img/default-img.f933a954.png";